/* tslint:disable */
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

// Import Containers
import { FullLayoutComponent} from './containers';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', component: FullLayoutComponent,canActivate: [AuthGuard], data: { title: 'Home' }, children: [
      {
        path: 'grupo',
        loadChildren: 'app/grupo/grupo.module#GrupoModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Grupos' }
      },
      {
        path: 'log',
        loadChildren: 'app/log/log.module#LogModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Log' }
      },
      {
        path: 'usuario',
        loadChildren: 'app/usuario/usuario.module#UsuarioModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Usuarios' }
      },
      {
        path: 'parametros',
        loadChildren: 'app/parametros/parametros.module#ParametrosModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Parametros' }
      },
      {
        path: 'home',
        loadChildren: 'app/home/home.module#HomeModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Mensagem' }
      },
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/app.routing.ts